import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { SNItem } from './snitem';

@RegisterItem()
export class CNReportDocument extends SNItem {
    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'stvaast_rapportconsultation_document';
    }
}
